import { useNavigate } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';
import HistoryTimeline from '../../components/common/HistoryTimeline';
import '../Context/ContextView.css';
import './FactDerivationView.css';

const FactDerivationView = () => {
  const navigate = useNavigate();

  return (
    <div className="view-container derivation-page">
      <header className="view-header">
        <div className="header-text">
          <h1>Fact Derivation</h1>
          <p>Trace the lineage of extracted facts and analyze how they evolved across history logs.</p>
        </div>
        <button className="help-detail-trigger" onClick={() => navigate('/app/help/context')}>
          <HelpCircle size={18} />
          <span>Module Details</span>
        </button>
      </header>
      <HistoryTimeline />
    </div>
  );
};

export default FactDerivationView;
